exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kj-no_data[data-v-4710ce46]{margin:44px 0 72px}.kj-no_data-img[data-v-4710ce46]{display:block;margin:0 auto 15px;width:40px;height:40px}.kj-no_data-tips[data-v-4710ce46]{font-size:14px;line-height:20px;color:#999;text-align:center}", "", {"version":3,"sources":["/Users/Min/Work/Code/ThirdApps/kanjia/front/src/base/noData/index.vue"],"names":[],"mappings":"AACA,6BACE,kBAAoB,CACrB,AACD,iCACE,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,WAAa,CACd,AACD,kCACE,eAAgB,AAChB,iBAAkB,AAClB,WAAY,AACZ,iBAAmB,CACpB","file":"index.vue","sourcesContent":["\n.kj-no_data[data-v-4710ce46] {\n  margin: 44px 0 72px;\n}\n.kj-no_data-img[data-v-4710ce46] {\n  display: block;\n  margin: 0 auto 15px;\n  width: 40px;\n  height: 40px;\n}\n.kj-no_data-tips[data-v-4710ce46] {\n  font-size: 14px;\n  line-height: 20px;\n  color: #999;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4710ce46","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/base/noData/index.vue
// module id = 235
// module chunks = 0